import { render, staticRenderFns } from "./Totaltime.vue?vue&type=template&id=7473d659&scoped=true&"
import script from "./Totaltime.vue?vue&type=script&lang=js&"
export * from "./Totaltime.vue?vue&type=script&lang=js&"
import style0 from "./Totaltime.vue?vue&type=style&index=0&id=7473d659&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7473d659",
  null
  
)

export default component.exports